import React from 'react';
import './CTA.css';
import { images } from '../../constants';

const CTA = () => {
  return (
    <div className="section-padding">
<div className="row cta">
    <div className="col-lg-8 col-12">
<h3>আমাদের লক্ষ্য</h3>

<p className="pt-2 pb-4">আমাদের মূল লক্ষ্য হল Ai তে দক্ষ একটা প্রজন্ম গড়ে তোলা যারা আগামীর বিশ্বকে Ai সেক্টরে নেতৃত্ব দিতে পারবে। আমরা Gen Z কে Gen Ai বানানোর পরিকল্পনা বাস্তবায়ন করতে চাই। সবার সহযোগিতা পেলে আমাদের এ কাজ সহজ ও তরান্বিত হবে; তাই আমরা অনেকটা সামাজিক ব্যবসার আদলে আমাদের এ প্রকল্প হাতে নিয়েছি।</p>
{/* <buton className="btn-positivus">Get your free proposal</buton> */}
</div>
<div className="col-lg-4 d-lg-flex d-none">
<img src={images.thingshappen} alt="thingshappen" />
</div>
    </div>
    </div>
  )
}

export default CTA